import z, { object, literal, discriminatedUnion, preprocess } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { AwardType } from '@occc-app/offerHelpers/types';
import { withIsEnabled, AwardPointsSchema, PartialAwardVouchersSchema } from '@occc/validation';
import {
  LimitDisabledSchemaWithIsEnabled,
  LimitSchema,
  validateMembershipLessThanGlobal,
} from '@occc/feat-limits';

import { BaseConfigurationSchema } from './base-configuration.schema';

import { AWARD_TYPES } from '../types';

const AwardCountEnabledSchema = object({
  membership: LimitSchema,
  global: LimitSchema,
}).superRefine((data, ctx) => {
  validateMembershipLessThanGlobal({
    membership: data.membership,
    global: data.global,
    ctx,
  });
});

const AwardCountDisabledSchema = object({
  membership: preprocess(() => ({}), LimitDisabledSchemaWithIsEnabled),
  global: preprocess(() => ({}), LimitDisabledSchemaWithIsEnabled),
});

const AwardCountSchema = withIsEnabled(AwardCountEnabledSchema, AwardCountDisabledSchema);

const ExternalFulfillmentEarningMechanismSchema = discriminatedUnion('awardType', [
  object({
    awardType: literal(AwardType.AwardPoints),
    awardPoints: preprocess((data) => data ?? {}, AwardPointsSchema),
  }),
  object({
    awardType: literal(AwardType.AwardVouchers),
    awardVouchers: preprocess((data) => data ?? {}, PartialAwardVouchersSchema),
  }),
  object({
    awardType: literal(AwardType.AwardNullable),
  }),
]);

const ExternalFulfillmentSchema = BaseConfigurationSchema.extend({
  awardType: literal(AWARD_TYPES.EXTERNAL_FULFILLMENT),
  externalFulfillment: preprocess((val) => val ?? {}, ExternalFulfillmentEarningMechanismSchema),
  awardCount: AwardCountSchema,
});

export type ExternalFulfillmentFormValues = z.infer<typeof ExternalFulfillmentSchema>;

export const validateExternalFulfillmentForm = makeValidate(ExternalFulfillmentSchema);
